/* eslint-disable no-console */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import Axios from 'axios'
import {useCallback, useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {VmoDivider, VmoIcon} from 'vmo-library'

import {UPDATE_USER_NOTIFICATION} from 'actions/types'
import {DESK_DESK} from 'actions/endpoint'
import {getUserNotifications, markAsRead} from 'actions/user_notifications'
import {getAppToken} from 'utils/local-storage'
import io from 'socket'
import {urlBase64ToUint8Array} from 'utils/helper'

const UserNotification = () => {
  const dispatch = useDispatch()
  const [page, setPage] = useState(1)
  const {notificationData = [], isReadNotification = [], limit} = useSelector(state => state.usersNotification)
  const {successLabels = []} = useSelector(state => state.apiReducer)

  const handleScroll = event => {
    const {scrollTop, clientHeight, scrollHeight} = event.currentTarget
    if (scrollHeight - scrollTop - clientHeight <= 1) {
      if (notificationData.length >= limit) {
        setPage(prev => prev + 1)
        dispatch({type: 'SET_LIMIT', payload: limit})
        dispatch({
          type: 'APPEND_NOTIFICATION',
          payload: notificationData,
        })
      }
    }
  }

  const subscribePushEvent = useCallback(async () => {
    try {
      if (navigator.serviceWorker) {
        console.log('inside service worker')

        const registration = await navigator.serviceWorker.register(
          `https://${window.location.host}/v1/desk/worker.js`,
          {scope: '/support'}
        )

        const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(
            'BO2CyeOEM7_JlBXN1H1g55NV8CABgIjUBkogjmerwJvJdXPOz50BfTPF5bbXdpiK3yeCB2naE20NHG2SHkmIl1c'
          ),
        })

        const token = `Bearer ${getAppToken()}`

        await Axios(`${DESK_DESK}/user-notifications/subscribe`, {
          method: 'POST',
          data: subscription,
          headers: {Authorization: token},
        })
      }
    } catch (error) {
      console.error('service worker error', error)
    }
  }, [])

  useEffect(() => {
    subscribePushEvent()
  }, [subscribePushEvent])

  useEffect(() => {
    io.on('user_notification', notification => {
      dispatch({
        type: 'APPEND_NOTIFICATION',
        payload: notification,
      })
    })

    return () => {
      io.off('user_notification')
    }
  }, [dispatch])

  useEffect(() => {
    dispatch(getUserNotifications(1))
  }, [dispatch])

  useEffect(() => {
    if (successLabels.includes(UPDATE_USER_NOTIFICATION)) {
      dispatch(getUserNotifications())
    }
  }, [successLabels, dispatch, page])

  if (notificationData.length === 0) {
    return <p style={{texAlign: 'center'}}>No New Notification </p>
  }
  return (
    <div onScroll={handleScroll}>
      {notificationData
        .sort((a, b) => b.id - a.id)
        .map(({description, id}) => (
          <p
            key={id}
            className="pr-3"
            onClick={() => {
              if (!isReadNotification.includes(`${id}`)) {
                dispatch(markAsRead(id))
              }
            }}
          >
            {description}
            {isReadNotification.includes(`${id}`) && (
              <VmoIcon
                name="icon circle"
                size="small"
                color="green"
                style={{
                  position: 'absolute',
                  right: '0px',
                  top: '5px',
                }}
              />
            )}
            <VmoDivider />
          </p>
        ))}
    </div>
  )
}

export default UserNotification
